import { Map } from "../reducers/map/mapReducer";
import Client from "./network";

export const updatePartialMapOnServer = (map: Partial<Map>, mapId: string | undefined) => {
    if(!mapId) {
        return;
    }
    Client.request(`/api/map/${mapId}/partialUpdate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...map }),
    }).then(() => {
        return;
    }).catch(() => {
        // do nothing
    });
};
